import { logger } from '@vista/omnichannel-components-domain';
import { getFieldValidatorForConfig } from './get-field-validator-for-config';
export const validateField = async (validationConfig, fieldData) => {
    if (!validationConfig) {
        logger.error(`Attempted to validate value '${fieldData}' with no validation config`);
        return undefined;
    }
    const validator = getFieldValidatorForConfig(validationConfig);
    return validator(fieldData);
};
